import axios from "axios";
import * as actions from "./actionsType";
import messages from '../messages';
import toastr from "toastr";
import CompanyResponsibles from "./CompanyResponsibles.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCompanyResponsible = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPANY_RESPONSIBLE,
      payload: true,
    });
    const resp = await CompanyResponsibles.getCompanyResponsible(filters);
    dispatch({
      type: actions.GET_COMPANY_RESPONSIBLE,
      payload: {
        companyResponsibles: resp.data.users,
        companyResponsiblesLength: resp.data.conteo,
      },
    });
    dispatch({
      type: actions.COMPANY_RESPONSIBLE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPANY_RESPONSIBLE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPANY_RESPONSIBLE,
      payload: false,
    });
  }
};

export const getCompanyResponsibleSelects = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPANY_RESPONSIBLE,
      payload: true,
    });

    const resp = await CompanyResponsibles.getCompanyResponsibleSelects(filters);
    dispatch({
      type: actions.GET_COMPANY_RESPONSIBLE_SELECTS,
      payload: resp.data.users
    });
    dispatch({
      type: actions.COMPANY_RESPONSIBLE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPANY_RESPONSIBLE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPANY_RESPONSIBLE,
      payload: false,
    });
  }
};

export const getCompanyResponsibleById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_COMPANY_RESPONSIBLE,
      payload: true,
    });
    const resp = await CompanyResponsibles.getCompanyResponsibleByID(id);
    dispatch({
      type: actions.GET_COMPANY_RESPONSIBLE,
      payload: {
        companyResponsibles: resp.data,
      },
    });
    dispatch({
      type: actions.COMPANY_RESPONSIBLE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.COMPANY_RESPONSIBLE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPANY_RESPONSIBLE,
      payload: false,
    });
  }
};

export const saveCompanyResponsible =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_COMPANY_RESPONSIBLE,
        payload: true,
      });
      const resp = await CompanyResponsibles.saveCompanyResponsible(data);
      const { companyResponsibles, companyResponsiblesLength } = getState().companyResponsible;
      const _companyResponsibles = [...companyResponsibles, resp.data];
      dispatch({
        type: actions.GET_COMPANY_RESPONSIBLE,
        payload: {
          companyResponsibles: _companyResponsibles,
          companyResponsiblesLength: companyResponsiblesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_COMPANY_RESPONSIBLE,
        payload: false,
      });
    }
  };

export const editCompanyResponsible =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_COMPANY_RESPONSIBLE,
        payload: true,
      });
      debugger
      const resp = await CompanyResponsibles.editCompanyResponsible(id, data);
      const { companyResponsibles, companyResponsiblesLength } = getState().companyResponsible;
      const _companyResponsibles = [...companyResponsibles]
      _companyResponsibles[index] = resp.data.users[0];
      dispatch({
        type: actions.GET_COMPANY_RESPONSIBLE,
        payload: {
          companyResponsibles: _companyResponsibles,
          companyResponsiblesLength: companyResponsiblesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : messages.errorMessage;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : messages.errorMessage;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_COMPANY_RESPONSIBLE,
        payload: false,
      });
    }
  };

export const deleteCompanyResponsible = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_COMPANY_RESPONSIBLE,
      payload: true,
    });
    await CompanyResponsibles.deleteCompanyResponsible(id);
    const { companyResponsibles, companyResponsiblesLength } = getState().companyResponsible;
    const _companyResponsibles = [...companyResponsibles]
    _companyResponsibles.splice(index, 1);
    dispatch({
      type: actions.GET_COMPANY_RESPONSIBLE,
      payload: {
        companyResponsibles: _companyResponsibles,
        companyResponsiblesLength: companyResponsiblesLength - 1,
      },
    });
    dispatch({
      type: actions.COMPANY_RESPONSIBLE_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.COMPANY_RESPONSIBLE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_COMPANY_RESPONSIBLE,
      payload: false,
    });
  }
};
